import React from 'react';

import styles from "../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";

export const AthleteWidgetEntityPlaceholder = ({device, imageSize, textTopMargin, imageMarginTop}: AthleteWidgetHeaderPlaceholderProps) => {
  const {isSmallView} = device;

  const roundProps = {
    className: classNames(styles.round),
    style: {width: imageSize, height: imageSize, marginTop: imageMarginTop},
  }

  const textProps = {
    className: classNames(styles.text),
    style: {marginTop: textTopMargin},
  }

  return (
    <div className={classNames(styles.entity, {[styles.small_view]: isSmallView})}>
      <div {...roundProps}/>
      <div {...textProps}/>
      <div className={classNames(styles.subtext)}/>
    </div>
  )
}
